import React from 'react';
import { connect } from "react-redux";
import infoActions from "../../components/info/info-actions";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import {
    emptyMoveRequest,
    getMoveHistoryStatus, getMoveRequest,
    navLinks, processMoveRequestAfterGet
} from "../../services/goods";
import Content from "../../components/content/Content";
import ActionButton from "../../components/button/ActionButton";
import DataTable from "../../components/data-table/DataTable";
import MoveLeftFields from "./MoveLeftFields";
import {getFalseResult} from "../../services/common";
import {withRouter} from "react-router";

const columnData = [
    { id: 'dt', numeric: false, disablePadding: false, label: 'Дата и время', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
    { id: 'oldStatus', numeric: false, disablePadding: false, label: 'Старый статус' },
    { id: 'newStatus', numeric: false, disablePadding: false, label: 'Новый статус' },
    { id: 'user', numeric: false, disablePadding: false, label: 'Пользователь' },
    { id: 'comment', label: 'Комментарий' },
];

@withRouter
class HistoryMoveStatusPage extends React.Component
{
    state = {
        id: null,
        moveRequest: emptyMoveRequest,
        refreshTable: false,
    };

    componentDidMount() {
        const path = this.props.location.pathname;
        const reId = new RegExp('[^/]+$');
        const resultId = reId.exec(path);
        if (resultId.length) {
            this.setState({id: resultId[0], refreshTable: !this.state.refreshTable});

            if (resultId[0] !== "0") {
                getMoveRequest(resultId[0])
                    .then(response => {
                        if (response.success) {
                            this.setState({
                                moveRequest: processMoveRequestAfterGet(response.data),
                            })
                        }
                    });
            }
        }
    }

    handleClickBack = () => {
        this.props.history.push(`/goods/move/view/${this.state.id}`);
    };

    getTableData = (...params) => {
        return this.state.id ? getMoveHistoryStatus(this.state.id, ...params) : getFalseResult();
    };

    render() {
        const { refreshTable, moveRequest } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <MoveLeftFields moveRequest={moveRequest}/>
                    <br/><br/>
                    <ActionButton onClick={this.handleClickBack}>Назад</ActionButton>
                </LeftBar>

                <Content title="История изменения статусов запроса">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        refresh={refreshTable}
                        selector={false}
                        pagination={false}
                    />
                </Content>
            </React.Fragment>
        );
    }
}

export default connect(null, {showInfo: infoActions.show})(HistoryMoveStatusPage);
